import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import NumberInput from '../../../../../../../../../../../../components/forms/number-input/NumberInput';
import TextInput from '../../../../../../../../../../../../components/forms/text-input/TextInput';
import TooltipIcon from '../../../../../../../../../../../../components/tooltip-icon/TooltipIcon';
import { EMISSION_MAX_FRACTION_DIGIT } from '../../../../../../../../../../../../shared/constants/products.constant';
import ManufacturerDropDown from './components/manufacturer-dropdown/ManufacturerDropdown';

interface InjectionMoldingMainMachineFormProps {
  processIndex: number;
  machineIndex: number;
}

const InjectionMoldingMainMachineForm = ({
  processIndex,
  machineIndex,
}: InjectionMoldingMainMachineFormProps): JSX.Element => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <div className='grid'>
      <div className='col-12'>
        <ManufacturerDropDown
          name={`processes[${processIndex}].machines[${machineIndex}].manufacturer_id`}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.manufacturer',
          )}
        />
      </div>

      <div className='col-8'>
        <TextInput
          name={`processes[${processIndex}].machines[${machineIndex}].model`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.model',
          )}
        />
      </div>
      <div className='col-4'>
        <NumberInput
          name={`processes[${processIndex}].machines[${machineIndex}].number_of_cavities`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.numberOfCavities',
          )}
          minFractionDigits={0}
          maxFractionDigits={0}
        />
      </div>
      <div className='col-4'>
        <NumberInput
          name={`processes[${processIndex}].machines[${machineIndex}].cycle_time`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.cycleTime',
          )}
          suffix=' s'
          minFractionDigits={0}
          maxFractionDigits={2}
        />
      </div>

      <div className='col-4'>
        <NumberInput
          name={`processes[${processIndex}].machines[${machineIndex}].shot_weight`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.shotWeight',
          )}
          suffix=' kg'
          minFractionDigits={0}
          maxFractionDigits={EMISSION_MAX_FRACTION_DIGIT}
          customIcon={
            <TooltipIcon
              id='shotWeightMainMachine'
              position='right'
              tooltipText={t(
                'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.toolTipTexts.shotWeight',
              )}
            />
          }
        />
      </div>

      <div className='col-4'>
        <NumberInput
          name={`processes[${processIndex}].machines[${machineIndex}].rated_power`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.placeholders.ratedPower',
          )}
          suffix=' kW'
          minFractionDigits={0}
          maxFractionDigits={2}
          customIcon={
            <TooltipIcon
              id='ratedPowerMainMachine'
              position='right'
              autoHide={false}
              template={
                <Trans
                  i18nKey='footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.inputs.toolTipTexts.ratedPowerMainMachine'
                  components={[
                    <a
                      key='0'
                      href='https://www.researchgate.net/publication/280266284_Energy_performance_evaluation_and_improvement_of_unit-manufacturing_processes_Injection_molding_case_study'
                      target='_blank'
                      rel='noreferrer'
                      className='text-primary underline'
                    />,
                  ]}
                />
              }
            />
          }
        />
      </div>
    </div>
  );
};

export default InjectionMoldingMainMachineForm;
